import UserContext from './UserContext'

const UserConsumer = UserContext.Consumer ;

export default UserConsumer ;